import { render, staticRenderFns } from "./GroupEditDialog.vue?vue&type=template&id=6bbbbf40&scoped=true&"
import script from "./GroupEditDialog.vue?vue&type=script&lang=js&"
export * from "./GroupEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./GroupEditDialog.vue?vue&type=style&index=0&id=6bbbbf40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbbbf40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bbbbf40')) {
      api.createRecord('6bbbbf40', component.options)
    } else {
      api.reload('6bbbbf40', component.options)
    }
    module.hot.accept("./GroupEditDialog.vue?vue&type=template&id=6bbbbf40&scoped=true&", function () {
      api.rerender('6bbbbf40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProvisionData/components/GroupEditDialog.vue"
export default component.exports